var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuDeveloper(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 9,
    viewBox: "0 0 12 9",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8046_6321)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8046_6321",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 12,
    height: 9
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 0H0V9H12V0Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8046_6321)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.96863 6.79376C7.80457 6.79376 7.66395 6.72344 7.5702 6.55938C7.42957 6.34844 7.49988 6.04376 7.73426 5.90313L10.1014 4.45001V4.42657L7.73426 2.97344C7.52332 2.83282 7.45301 2.55157 7.5702 2.31719C7.71082 2.10626 7.99207 2.03594 8.22641 2.15313L10.7108 3.70001L10.7577 3.74688C11.1327 4.12188 11.1327 4.75469 10.7577 5.15313L10.7108 5.20001L8.22641 6.74688C8.13271 6.77032 8.03891 6.79376 7.96863 6.79376Z",
    fill: "url(#paint0_linear_8046_6321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.04687 6.79383C2.95312 6.79383 2.88281 6.77039 2.8125 6.72352L0.32812 5.17664L0.28125 5.1532C-0.09375 4.7782 -0.09375 4.14539 0.28125 3.74695L0.32812 3.70008L2.8125 2.1532C3.02343 2.01258 3.32812 2.08289 3.46875 2.31727C3.60937 2.5282 3.53906 2.83289 3.30468 2.97352L0.9375 4.42664V4.45008L3.30468 5.9032C3.51562 6.04383 3.58593 6.32508 3.46875 6.55945C3.375 6.72352 3.21093 6.79383 3.04687 6.79383Z",
    fill: "url(#paint1_linear_8046_6321)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M3.98413 8.90305C3.93726 8.90305 3.86695 8.90305 3.82007 8.87965C3.5857 8.78585 3.46851 8.50465 3.53882 8.27025L6.5857 0.301514C6.67945 0.0671438 6.9607 -0.0500462 7.19507 0.0202638C7.42945 0.114014 7.54663 0.395264 7.47632 0.629644L4.42945 8.59835C4.35913 8.78585 4.17163 8.90305 3.98413 8.90305Z",
    fill: "url(#paint2_linear_8046_6321)"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8046_6321",
    x1: 9.2685,
    y1: 2.09668,
    x2: 9.2685,
    y2: 6.79376,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_8046_6321",
    x1: 1.77045,
    y1: 2.08105,
    x2: 1.77045,
    y2: 6.79383,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_8046_6321",
    x1: 5.50757,
    y1: 0,
    x2: 5.50757,
    y2: 8.90305,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C0C0C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5A5A5A"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8046_6321"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 12,
    height: 9,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuDeveloper);
export default __webpack_public_path__ + "static/media/Menu-Developer.f897ef35e67ff5deb4ffdadcaca5a504.svg";
export { ForwardRef as ReactComponent };